declare namespace $ {

	type $mol_button_minor__title_shm_hitalama_profile_page_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_profile_page_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['exit'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_hitalama_profile_badge__avatar_uri_shm_hitalama_profile_page_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['avatar_uri'] >
		,
		ReturnType< $shm_hitalama_profile_badge['avatar_uri'] >
	>
	type $shm_hitalama_profile_badge__name_shm_hitalama_profile_page_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['login'] >
		,
		ReturnType< $shm_hitalama_profile_badge['name'] >
	>
	type $shm_hitalama_file_attach__files_shm_hitalama_profile_page_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['avatar_files'] >
		,
		ReturnType< $shm_hitalama_file_attach['files'] >
	>
	type $shm_hitalama_file_attach__sub_shm_hitalama_profile_page_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_file_attach['sub'] >
	>
	type $mol_button_minor__title_shm_hitalama_profile_page_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_profile_page_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['avatar_delete'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_profile_page_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_string__value_shm_hitalama_profile_page_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['login'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_profile_page_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_button_major__title_shm_hitalama_profile_page_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_profile_page_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__enabled_shm_hitalama_profile_page_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['save_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_view__sub_shm_hitalama_profile_page_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_button_copy__title_shm_hitalama_profile_page_20 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__text_shm_hitalama_profile_page_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['secret_key'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $shm_button_copy__title_shm_hitalama_profile_page_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['client_id'] >
		,
		ReturnType< $shm_button_copy['title'] >
	>
	type $shm_button_copy__hint_shm_hitalama_profile_page_25 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_button_copy['hint'] >
	>
	type $shm_button_copy__text_shm_hitalama_profile_page_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['client_id'] >
		,
		ReturnType< $shm_button_copy['text'] >
	>
	type $mol_labeler__title_shm_hitalama_profile_page_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_shm_hitalama_profile_page_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_text__attr_shm_hitalama_profile_page_29 = $mol_type_enforce<
		({ 
			'status': ReturnType< $shm_hitalama_profile_page['message_status'] >,
		})  & ReturnType< $mol_text['attr'] >
		,
		ReturnType< $mol_text['attr'] >
	>
	type $mol_text__text_shm_hitalama_profile_page_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_profile_page['message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_hitalama_profile_page extends $shm_hitalama_guide_page {
		exit( next?: any ): any
		Exit_header( ): $mol_button_minor
		avatar_files( next?: readonly(File)[] ): readonly(File)[]
		avatar_uri( ): string
		login( next?: string ): string
		Avatar_preview( ): $shm_hitalama_profile_badge
		Avatar_upload( ): $shm_hitalama_file_attach
		avatar_delete( next?: any ): any
		Avatar_delete( ): $mol_button_minor
		avatar_delete_visible( ): readonly(any)[]
		Avatar_tools( ): $mol_view
		Avatar_label( ): $mol_labeler
		save( next?: any ): any
		Login( ): $mol_string
		Login_label( ): $mol_labeler
		save_enabled( next?: boolean ): boolean
		Save( ): $mol_button_major
		Login_tools( ): $mol_view
		secret_key( ): string
		Secret_copy( ): $shm_button_copy
		Secret_label( ): $mol_labeler
		client_id( ): string
		Client_copy( ): $shm_button_copy
		Client_label( ): $mol_labeler
		message_status( ): string
		message( next?: string ): string
		Message( ): $mol_text
		title( ): string
		help_section( ): string
		tools( ): readonly(any)[]
		profiles( ): $shm_hitalama_profile_dict
		message_login_empty( ): string
		message_login_exists( ): string
		message_saved( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map